import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminBusinessDataApi, adminConfigurationDataApi, adminCtrBoosterApi, adminDashboardCountApi, adminPlansDataApi, adminScansDataApi, adminUserDataApi } from "../../apis";
import { adminBusinessListSimplifiedApi, adminBusinessPaginationDataApi, adminScanPaginationDataApi, adminUserListSimplifiedApi, adminUserPaginationDataApi, getAdminManagerListApi, deleteAdminManagerApi, addAdminManagerApi, IPagination } from "../../apis/AdminApis/AdminDataApi";

export const adminManagerListAction = createAsyncThunk("admin/manager-list", async (_, { rejectWithValue }) => {
    try {
        const response = await getAdminManagerListApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get manager list" });
    }
})

export const adminDeleteManagerAction = createAsyncThunk("admin/delete-manager", async (data: { id: string | null }, { rejectWithValue }) => {
    try {
        const response = await deleteAdminManagerApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not delete manager" });
    }
})

export const adminAddManagerAction = createAsyncThunk("admin/add-manager", async (data: any, { rejectWithValue }) => {
    try {
        const response = await addAdminManagerApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not add manager" });
    }
})

export const adminDashboardCountAction = createAsyncThunk("admin/dashboard-count", async (_, { rejectWithValue }) => {
    try {
        const response = await adminDashboardCountApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin dashboard count" });
    }
})

export const adminUserDataAction = createAsyncThunk("admin/user-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminUserDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin user data" });
    }
})

export const adminUserPaginationDataAction = createAsyncThunk("admin/user-pagination-data", async (data: IPagination, { rejectWithValue }) => {
    try {
        const response = await adminUserPaginationDataApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin user data" });
    }
})

export const adminBusinessDataAction = createAsyncThunk("admin/business-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminBusinessDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin business data" });
    }
})

export const adminBusinessPaginationDataAction = createAsyncThunk("admin/business-pagination-data", async (data: IPagination, { rejectWithValue }) => {
    try {
        const response = await adminBusinessPaginationDataApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin business data" });
    }
})

export const adminScansDataAction = createAsyncThunk("admin/scans-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminScansDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin scans data" });
    }
})

export const adminScanPaginationDataAction = createAsyncThunk("admin/scan-pagination-data", async (data: IPagination, { rejectWithValue }) => {
    try {
        const response = await adminScanPaginationDataApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin scan data" });
    }
})

export const adminConfigurationDataAction = createAsyncThunk("admin/configuration-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminConfigurationDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin configuration data" });
    }
})

export const adminCtrBoosterAction = createAsyncThunk("admin/ctrs-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminCtrBoosterApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin ctr booster data" });
    }
})

export const adminPlansDataAction = createAsyncThunk("admin/plans-data", async (_, { rejectWithValue }) => {
    try {
        const response = await adminPlansDataApi()
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin plan data" });
    }
})

export const adminUserListSimplifiedAction = createAsyncThunk("admin/user-list-simplified", async (data: IPagination, { rejectWithValue }) => {
    try {
        const response = await adminUserListSimplifiedApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin user list simplified" });
    }
})

export const adminBusinessListSimplifiedAction = createAsyncThunk("admin/business-list-simplified", async (data: { userId: string }, { rejectWithValue }) => {
    try {
        const response = await adminBusinessListSimplifiedApi(data)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get admin business list simplified" });
    }
})